import { Modal } from "@mui/material";
import { FC, ReactNode } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export const CustomModal: FC<Props> = ({ open, onClose, children }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {children}
      </div>
    </Modal>
  );
};
